import { kernelsClient, LegacyDataSource } from "@kaggle/sdk";
import TerminalMessage from "../../../types/TerminalMessage";
import { appendTerminalError } from "../../actions/terminal";
import {
  getCurrentDataSourceReferences,
  getCurrentKernelRunId,
} from "../../selectors/current";
import { getStore } from "../../store/appStore";
import { setDataSourceReferences, setDataSources } from "../notebook";
import { appendTerminal } from "../terminal";
import { updateWorker } from "../worker";

export const addDataSource = async (sources: LegacyDataSource[]) => {
  const state = getStore().getState();

  try {
    if (!state.notebook.kernel) {
      throw new Error(
        "Cannot add data source when no kernelId exists in state."
      );
    }

    const fingerprintSource = (source: LegacyDataSource) =>
      `${source.sourceType}:${source.sourceId}`;

    const existingSources = getCurrentDataSourceReferences(state);
    const existingFingerprints = existingSources.map(fingerprintSource);

    const normalizeDataSource = (source: LegacyDataSource) => {
      return {
        sourceType: source.sourceType,
        sourceId: source.sourceId,
        datasetId: source.datasetId,
        databundleVersionId: null,
        mountSlug: source.mountSlug,
      };
    };

    const newSources = sources
      // Dedupe by sourceType:sourceId combination.
      .filter(
        source => !existingFingerprints.includes(fingerprintSource(source))
      )
      .map(normalizeDataSource);

    const dataSources = existingSources.concat(newSources);

    appendTerminal([
      new TerminalMessage("Updating data sources...", dataSources),
    ]);

    // Updates app state to reflect new data sources.
    // This triggers a draft save in middleware.
    setDataSourceReferences(dataSources);
    await updateWorker({updateDatasets: true, useLegacyOnly: true});

    // Update the list of data dataSources
    // TODO(mbooth): Avoid refreshing the entire data tree
    const kernelSessionId = getCurrentKernelRunId(state);
    if (kernelSessionId) {
      const notebookResponse = await kernelsClient.getKernelSessionDataSources({
        kernelSessionId,
        includeOutputFiles: true,
      });
      setDataSources(
        notebookResponse.dataSources.map(s => ({
          ...s,
          refreshAvailable: false,
        }))
      );
    }
  } catch (error) {
    appendTerminalError("An error occurred adding a data source.", error);
    throw error;
  }
};
